import React, {useState} from "react";
import PropTypes from 'prop-types';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import ColumnsSetup from "./ColumnsSetup";
import {getLabelByName} from "./getLabelByName";
import DefaultType from "../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../JsonScreen/Utils/lib";


const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        padding: 10
    },
    itemContainer: {
        display: 'flex',
        alignItems: 'center',
        height: 45,
    },
    item: {
        display: 'flex', width: 200, alignItems: 'center', justifyContent: 'space-between'
    },
    chipContainer: {
        display: 'flex',
        minHeight: 24
    }
}));

const defaultColumnSetup = {
    open: false,
    type: null,
    label: null
};

const OtherSettings = (props) => {
    const {schema, listFields, labelFields, dropDownFields, editScreen, setValue} = props;
    const [openColumnSetup, setOpenColumnSetup] = useState(defaultColumnSetup);
    const classes = useStyles();
    const {userLanguage} = useSelector(state => state.app);
    return (
        <div className={classes.container}>

            {/*listFields*/}
            <div className={classes.itemContainer}>
                <div className={classes.item}>
                    <Typography color={"textSecondary"}>
                        List Columns
                    </Typography>
                    <Typography color={"textSecondary"}>
                        <IconButton onClick={() => setOpenColumnSetup({
                            type: 'listFields',
                            label: 'List Columns',
                            open: true
                        })}>
                            <Icon>library_add_check</Icon>
                        </IconButton>
                    </Typography>
                </div>

                <div style={{width: 'calc(100% - 200px)'}}>
                    <div className={classes.chipContainer}>
                        {listFields.map((item, index) => {
                            const multiLanguageLabel = multiLanguageValue(getLabelByName(item, schema), userLanguage)
                            return (
                                <Chip key={index} size="small" avatar={<Avatar>{multiLanguageLabel.charAt(0)}</Avatar>}
                                      label={multiLanguageLabel}
                                      style={{margin: '0 3px'}}/>
                            )
                        })}
                    </div>
                    <Divider style={{margin: '5px 0'}}/>
                </div>
            </div>
            {/*dropDownFields*/}
            <div className={classes.itemContainer}>
                <div className={classes.item}>
                    <Typography color={"textSecondary"}>
                        Dropdown Columns
                    </Typography>
                    <Typography
                        color={"textSecondary"}
                    >
                        <IconButton onClick={() => setOpenColumnSetup({
                            type: 'dropDownFields',
                            label: 'Dropdown Fields',
                            open: true
                        })}>
                            <Icon>library_add_check</Icon>
                        </IconButton>
                    </Typography>
                </div>
                <div style={{width: 'calc(100% - 200px)'}}>
                    <div className={classes.chipContainer}>
                        {dropDownFields.map((item, index) => {
                            const multiLanguageLabel = multiLanguageValue(getLabelByName(item, schema), userLanguage)
                            return(
                            <Chip key={index} size="small" avatar={<Avatar>{multiLanguageLabel.charAt(0)}</Avatar>}
                                  label={multiLanguageLabel}
                                  style={{margin: '0 3px'}}/>
                            )
                        })}
                    </div>
                    <Divider style={{margin: '5px 0'}}/>
                </div>
            </div>
            {/*labelFields*/}
            <div className={classes.itemContainer}>
                <div className={classes.item}>
                    <Typography color={"textSecondary"}>
                        Enrichment Field
                    </Typography>
                    <Typography color={"textSecondary"}>
                        <IconButton onClick={() => setOpenColumnSetup({
                            type: 'labelFields',
                            label: 'Enrichment Field',
                            open: true
                        })}>
                            <Icon>library_add_check</Icon>
                        </IconButton>
                    </Typography>
                </div>
                <div style={{width: 'calc(100% - 200px)'}}>
                    <div className={classes.chipContainer}>
                        {labelFields.map((item, index) => {
                            const multiLanguageLabel = multiLanguageValue(getLabelByName(item, schema), userLanguage)
                            return(
                                <Chip key={index} size="small" avatar={<Avatar>{multiLanguageLabel.charAt(0)}</Avatar>}
                                      label={multiLanguageLabel}
                                      style={{margin: '0 3px'}}/>
                            )
                        })}
                    </div>
                    <Divider style={{margin: '5px 0'}}/>
                </div>
            </div>

            {/* Edit Screen Path*/}
            <div style={{marginTop: 10}}>
                <DefaultType
                    values={{editScreen}}
                    field={{
                        type: 'string',
                        path: 'editScreen',
                        label: "Edit Screen Path",
                    }}
                    setValue={setValue}
                    labelStyles={{width: 198}}
                    fieldStyles={{width: 350}}
                />
            </div>

            <ColumnsSetup
                open={openColumnSetup.open}
                onClose={() => setOpenColumnSetup(defaultColumnSetup)}
                destination={
                    openColumnSetup.open ?
                        props[openColumnSetup.type]
                        : []
                }
                apply={setValue}
                schema={schema}
                fieldsType={openColumnSetup.type}
                label={openColumnSetup.label}
            />
        </div>
    )
};

export default OtherSettings

OtherSettings.propTypes = {
    schema: PropTypes.array,
    listFields: PropTypes.array,
    labelFields: PropTypes.array,
    dropDownFields: PropTypes.array,
    screenEdit: PropTypes.string,
    setValue: PropTypes.func.isRequired
};
OtherSettings.defaultProps = {
    schema: [],
    listFields: [],
    labelFields: [],
    dropDownFields: [],
    screenEdit: ""
};